import { ModalMain } from "../styled";
import { FontGreyDarkFullRegular, FontGreyDarkMediumTitle } from "../../../../utils/typografyApp";
import SecondaryButton from "../../SecondaryButton";
import PrimaryButton from "../../PrimaryButton";
import { DeleteAnomalieForm } from "./styled";
import { useDeleteAnomalieModalHook } from "./hook";
import { FormProvider } from "react-hook-form";

const DeleteAnomalieModal = ({ onClose, selectedAnomalie }) => {

    const hook = useDeleteAnomalieModalHook({ onClose, selectedAnomalie });

    return (
        <ModalMain>
            <FormProvider {...hook.form.asset3DItemForm}>
                <DeleteAnomalieForm>
                    
                        <div className={"menu-content"}>
                            <div className="content">
                                <div className="title">
                                    <FontGreyDarkMediumTitle>Deletar Anomalia</FontGreyDarkMediumTitle>
                                </div>
                                <FontGreyDarkFullRegular>Tem certeza que deseja excluir esta anomalia?</FontGreyDarkFullRegular>
                            </div>

                            <div className="actions-container">
                                <SecondaryButton disabled={hook.form.isLoading} onClick={onClose}>Voltar</SecondaryButton>
                                <PrimaryButton disabled={hook.form.isLoading} onClick={hook.form.onSubmit}> {hook.form.isLoading ? 'Excluindo...' : 'Excluir'} </PrimaryButton>
                            </div>
                        </div>
            
                </DeleteAnomalieForm>
            </FormProvider>
        </ModalMain>
    );
}

export default DeleteAnomalieModal;